export default {
  features: {
    alifshopOrderReject: {
      button: 'Buyurtmani bekor qilish',
    },
  },
};
